import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import { stringify } from "querystring";
import ModuleManager from "../../../../framework/core/module_manager";
import { RoadMap_cp_item } from "./roadmap_cp_item";
import PromiseUtility from "../../../../utility/promiseUtility";

const {ccclass, property} = cc._decorator;

@ccclass
export  class RoadMap_cp_view extends ViewBase {
    
    @property(cc.Node)
    itemPrefab: cc.Node = null

    @property(cc.Float)
    offset: number = 0

    @property(cc.Integer)
    maxCount: number = 1

    @property(cc.Float)
    duration: number = 0.5

    @property(cc.Float)
    appearDuration: number = 0.5

    protected m_item_pool_queue: RoadMap_cp_item[] = []
    protected m_item_queue: RoadMap_cp_item[] = []

    getItem(): RoadMap_cp_item{
        let item = this.m_item_pool_queue.shift()
        if(!item){
            let node = cc.instantiate(this.itemPrefab)
            node.parent = this.itemPrefab.parent
            item = node.getComponent(RoadMap_cp_item)
        }
        item.node.active = true
        return item
    }

    collectItem(item: RoadMap_cp_item){
        item.node.active = false
        this.m_item_pool_queue.push(item)
    }

    showPanel(list: number[], append: boolean){        
        if(!append){
            let count = this.m_item_queue.length
            for (let index = 0; index < count; index++) {
                this.collectItem(this.m_item_queue.shift())
            }
        }
        let appendList = []
        for (let index = 0; index < list.length; index++) {
            const element = list[index];
            let item = this.getItem()
            item.setData(element)
            appendList.push(item)
            this.m_item_queue.push(item)
        }
        this.do_layout(appendList, append)
    }

    do_layout(appendItems: RoadMap_cp_item[], append: boolean){
        let self = this
        let funList = []
        for (let index = 0; index < appendItems.length; index++) {
            const item = appendItems[index];
            if(this.m_item_queue.length > appendItems.length){
                let preItem = this.m_item_queue[this.m_item_queue.length - appendItems.length + index - 1]
                item.node.position = cc.v2(preItem.node.position.x - this.offset, preItem.node.position.y)
            }else{
                item.node.position = cc.v2(-index * this.offset, 0)
            }     
            let fun = function(cb){
                if(append){
                    item.playAppearEffect(cb)
                }else{                    
                    cb && cb()                    
                }
            } 
            funList.push(fun)
        }

        PromiseUtility.all(funList).then(function(){
            self.adjustLayout(append)
        })        
    }

    adjustLayout(withAnim: boolean){
        let self = this
        if(this.m_item_queue.length > this.maxCount){
            let offsetCount = this.m_item_queue.length - this.maxCount
            let needRemoveList = []
            for (let index = 0; index < this.m_item_queue.length; index++) {
                const item = this.m_item_queue[index];
                let offset = -(index - offsetCount) * this.offset
                let targetPos = cc.v2(offset, 0)
                if(withAnim){
                    this.do_move(item.node, targetPos, function(){
                        if(index - offsetCount < 0){
                            item.playDisappear(function(){
                                item.node.stopAllActions()
                                let tmpIndex = self.m_item_queue.indexOf(item)
                                self.m_item_queue.splice(tmpIndex, 1)
                                self.collectItem(item)
                            })
                        }
                    })
                }else{
                    item.node.position = targetPos
                    if(index - offsetCount < 0){
                        needRemoveList.push(item)
                    }
                }                
            }
            if(!withAnim){
                for (let index = 0; index < needRemoveList.length; index++) {
                    const item = needRemoveList[index];
                    item.node.stopAllActions()
                    let tmpIndex = self.m_item_queue.indexOf(item)
                    self.m_item_queue.splice(tmpIndex, 1)
                    self.collectItem(item)
                }
            }
        }
    }

    do_fadeOutIn(node: cc.Node, out: boolean, onFinish){            
        let fade = out? cc.fadeOut(this.appearDuration): cc.fadeIn(this.appearDuration)
        let tmpFun = cc.callFunc(function(){
            node['_lastFadeAction'] = null
            onFinish && onFinish()
        })
        let lastAction = node['_lastFadeAction']
        lastAction && node.stopAction(lastAction)
        let action = cc.sequence([fade, tmpFun])
        node['_lastFadeAction'] = action
        node.runAction(action)
    }

    do_move(node: cc.Node, targetPos: cc.Vec2, onFinish){
        let moveAnim = cc.moveTo(this.duration, targetPos)
        let tmpFun = cc.callFunc(function(){
            node['_lastMoveAction'] = null
            onFinish && onFinish()
        })
        let lastAction = node['_lastMoveAction']
        lastAction && node.stopAction(lastAction)
        let action = cc.sequence([moveAnim, tmpFun])
        node['_lastMoveAction'] = action
        node.runAction(action)
    }
}
